export enum ReservationType {
  Regular = 'Regular',
  Meeting = 'Meeting',
  Ltr = 'Ltr',
  Lab = 'Lab'
}

export enum ReservationClassification {
  SingleOffice = 'SingleOffice',
  Virtual = 'Virtual',
  Hybrid = 'Hybrid'
}

export enum ReservationStatus {
  Definite = 'Definite',
  NewRequest = 'NewRequest',
  Tentative = 'Tentative',
  Pipeline = 'Pipeline',
  Cancelled = 'Cancelled',
  DidNotMaterialize = 'DidNotMaterialize'
}

export enum ReservationFeatureFlag {
  Undefined = 'Undefined',
  IncludeVirtualBookings = 'IncludeVirtualBookings',
  IncludeMeetingWaitLists = 'IncludeMeetingWaitLists',
  IncludeSpaceBookings = 'IncludeSpaceBookings',
  IncludeAllowedStatusActions = 'IncludeAllowedStatusActions',
  IncludeItemCount = 'IncludeItemCount'
}

interface ReservationBookingBulkItem<T> {
  value: T,
  specified: boolean
}

export interface ReservationBookingBulkModifyInput {
  name: ReservationBookingBulkItem<string>;
  specialistId: ReservationBookingBulkItem<number>;
  setupTypeId: ReservationBookingBulkItem<number>;
  attendeesCount: ReservationBookingBulkItem<number>;
  startDate: ReservationBookingBulkItem<string>;
  startTime: ReservationBookingBulkItem<string>;
  endTime: ReservationBookingBulkItem<string>;
  spaceBookings: {
    id: number,
    revision: number
  }[];
}
